module.exports = __webpack_public_path__ + "img/1.0aedb9d6.jpg";